import { Box, Typography } from "@mui/material";
import { RotatingLines } from "react-loader-spinner";

// Loader Component
const Loader = ({ text }) => {
  const loadingText =
    typeof text === "string" && text.trim() !== "" ? text.trim() : null;

  return (
    <Box
      style={{
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",

        padding: "0px",
        margin: "0px",

        backgroundColor: "transparent",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      }}
    >
      <Box display="flex" justifyContent="center">
        <RotatingLines
          strokeColor="black"
          strokeWidth="5"
          animationDuration="0.75"
          width="96"
          visible={true}
        />
      </Box>
      {loadingText ? (
        <Box py={3} textAlign="center">
          <Typography variant="inherit" fontWeight="medium">
            {loadingText}
          </Typography>
        </Box>
      ) : null}
    </Box>
  );
};
export default Loader;
